import React from "react"

import Fade from "react-reveal/Fade"

// import './styles.scss';

class EventPlaceholder extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let {
      eventURL,

      className,
    } = this.props

    return (
      <div className={`event-list ${className}`}>
        <a href={eventURL} target="_blank" className="" rel="noreferrer">
          <div className="event-list-contents">
            <div className="event-list-featured">
              <div className="event-list-info">
                <Fade bottom delay={500}>
                  <p className="event-card-city">{"//TODO (Empty Date)"}</p>
                </Fade>
              </div>
              {/* {countdown && (
                <Countdown
                  className="event-list-countdown"
                  toDate={moment(eventDate)}
                  timeFormat="ddd, DD MMM YYYY HH:mm"
                />
              )} */}
            </div>
          </div>
        </a>
      </div>
    )
  }
}

export default EventPlaceholder
